<template>
  <section class="faqs"
           data-ivp-class="--animate"
           id="faqs">
    <header class="faq__header">
      <div class="container">
        <h3 class="uptitle">
          FREQUENTLY ASKED QUESTIONS
        </h3>
        <h2 class="title">
          Questions / Answers
        </h2>
        <p class="description">
          Don’t see your question answered below? Reach out to us at 
          <a href="mailto:invest@keepcannabislocal.com">
            invest@keepcannabislocal.com
          </a>
        </p>
      </div>
    </header>
    <div class="faqs-wrapper">
      <div class="container">
        <div class="faq-section"
            v-for="(section, idx) in faqs"
            v-bind:key="idx"
            v-bind:class="{'--full': section.width == 'full'}">
          <header class="faq-section__header">
            <h2 class="title">
              {{ section.title }}
            </h2>
          </header>
          <ul class="questions-list">
            <li class="question-item"
                v-for="(question, qid) in section.questions" v-bind:key="qid"
                v-bind:class="{'--active': question.active}">
              <h3 class="question"
                  v-html="question.question"
                  @click="question.active = !question.active"
                  v-bind:class="{'--active': question.active}">
              </h3>
              <div class="answer-wrapper"
                  >
                <p class="answer"
                  v-html="question.answer">
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/faqs.scss';
</style>

<script>
export default {
  name: 'Faqs',
  data() {
    return {
      faqs: [
        {
          title: 'Investing Basics',
          width: 'full',
          questions: [
            {question:`How do I invest?`,
            answer:`You can easily invest in our offering online using our secure investment page.`},
            {question:`How do I get more information about investing?`,
            answer:`You can view our offering circular and investor presentation at the link below. We recommend you read all materials before investing.<br>Offering Circular: Direct SEC Link<br>Investor Presentation: Download PDF<br>You can also email us at&nbsp;<a href="mailto:invest@keepcannabislocal.com">invest@keepcannabislocal.com</a>&nbsp;for more information.`},
            {question:`What is the price per share?`,
            answer:`The price per share is $1.12 USD.`},
            {question:`What is the minimum investment amount?`,
            answer:`The minimum investment amount is&nbsp;<strong>$560 USD</strong>&nbsp;or&nbsp;<strong>500 shares</strong>.`},
            {question:`What is the maximum investment amount?`,
            answer:`The maximum amount that you can invest as a non-accredited investor is 10% of the greater of your income or net worth. There is no limit for accredited investors.`},
            {question:`What is the difference between an accredited investor and a non-accredited investor?`,
            answer:`An accredited investor is an individual who makes over $200,000 per year in income ($300,000 if combined with a spouse) or who has a net worth of $1 million or more, excluding their primary residence.<br>A non-accredited investor is anyone who does not meet at least one of the income or net worth requirements for being considered an accredited investor.`},
            {question:`What methods of payment are accepted?`,
            answer:`We accept payments using a U.S. bank account (ACH), wire, or IRA.`},
            {question:`Do I have to be a U.S. citizen to invest?`,
            answer:`Our offering is open to both U.S. citizens as well as international investors.<br>Please note that the regulations of your country may restrict you from investing via Reg A+ offerings. As an investor, you must check the regulations that apply to you, in your country.Direct SEC Link<br>Investor Presentation: Download PDF<br>You can also email us at&nbsp;<a href="mailto:invest@keepcannabislocal.com">invest@keepcannabislocal.com</a>&nbsp;for more information.`},
            {question:`If I invest now, can I invest more in the future?`,
            answer:`You will be able to invest in this same offering until we close this funding round. We may or may not have an additional offering at some point in the future.`},
            {question:`Where can I see the stocks I've purchased?`,
            answer:`As an investor, you will be provided access to an investor-only website where you will be able to view your shares, investor updates, and other related documents and materials.`},
            {question:`How often will there be informational updates from the company?`,
            answer:`We aim to make an investment in Item 9 Labs Corp. both a great investment opportunity and also a great journey in which our investors can learn about our company, our brands and development. Therefore, we aim to have regular updates on our progress and activities. At a minimum, we will provide quarterly updates but we aim to have much more regular updates, (one to many per month) in the form of webinars, video updates, and email updates.`},
          ],
        },
        {
          title: 'Offering Details',
          questions: [
            {question:`How many shares are offered for investment by the company?`,
            answer:`We are offering a maximum of ___________ Common Shares.`},
            {question:`When does the offering close?`,
            answer:`Our offering will terminate on the first to occur of:`},
            {question:`What does it mean that the Securities and Exchange Commission has qualified this offering?`,
            answer:`“The SEC has qualified this offering” means the SEC has permitted Item 9 Labs Corp. to offer for sale the securities (also referred to as shares, stock or common stock) described in the offering circular to the general public. The SEC is not judging the merits, accuracy, or completeness of the offering and information in the offering circular. Rather, the SEC is merely ensuring Item 9 Labs Corp. has met federal legal disclosure and regulatory requirements necessary to make these shares available to you.`},
            {question:`What is a subscription agreement?`,
            answer:`A subscription agreement is a legal contract between you and Item 9 Labs Corp. to purchase shares issued by the company and is required for each investment you make.<br>Each investment is a one-time event and no recurring payments will be withdrawn from you for that investment.`},
          ]
        },
        {
          title: 'Post Offering',
          questions: [
            {question:`What happens after I invest?`,
            answer:`ACH transactions can take 1-2 business days to process. Once funds are received, it can take up to two weeks to process your investment completely.`},
            {question:`How will I be kept updated on the performance of my investment?`,
            answer:`We will update you on, at least, a quarterly basis. You will be able to log into the investor only website to see all our updates.`},
            {question:`What will capital raised by this offering be used for?`,
            answer:`Management of the company has wide latitude and discretion in the use of proceeds from this offering, including but not limited to manufacturing, marketing, business development expenses, and providing liquidity to early shareholders. Please read the ‘Use of Proceeds to the Company’ section in our offering curricular for more details on our plans for the future.`},
            {question:`How do I contact the company?`,
            answer:`For any questions about our offering, please email us at&nbsp;<a href="mailto:invest@keepcannabislocal.com">invest@keepcannabislocal.com</a>`},
            {question:`Why are you hosting the offering on your own website?`,
            answer:`When we first looked into raising capital via crowdfunding, we strongly considered signing with a platform but ultimately decided to host our own raise ourselves to reduce fees and leverage our expertise in digital marketing and advertising for a more successful raise opportunity.`},
          ],
        },
      ],
    };
  }
};
</script>